/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface OrganizationDetails
 */
export interface OrganizationDetails {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    org_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    tenant_name: string;
    /**
     * 
     * @type {Array<Organization>}
     * @memberof OrganizationDetails
     */
    managed_organizations?: Array<Organization>;
}

/**
 * Check if a given object implements the OrganizationDetails interface.
 */
export function instanceOfOrganizationDetails(value: object): value is OrganizationDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('org_name' in value) || value['org_name'] === undefined) return false;
    if (!('tenant_name' in value) || value['tenant_name'] === undefined) return false;
    return true;
}

export function OrganizationDetailsFromJSON(json: any): OrganizationDetails {
    return OrganizationDetailsFromJSONTyped(json, false);
}

export function OrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'org_name': json['org_name'],
        'tenant_name': json['tenant_name'],
        'managed_organizations': json['managed_organizations'] == null ? undefined : ((json['managed_organizations'] as Array<any>).map(OrganizationFromJSON)),
    };
}

export function OrganizationDetailsToJSON(json: any): OrganizationDetails {
    return OrganizationDetailsToJSONTyped(json, false);
}

export function OrganizationDetailsToJSONTyped(value?: OrganizationDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'org_name': value['org_name'],
        'tenant_name': value['tenant_name'],
        'managed_organizations': value['managed_organizations'] == null ? undefined : ((value['managed_organizations'] as Array<any>).map(OrganizationToJSON)),
    };
}

